import { Col, PageHeader, Row } from "antd";
import * as React from "react";
import { BlacklistTable, Tabs } from "src/components";
import DeskPanel from "src/components/DeskPanel/DesktPanel";

export interface IBlacklistProps {}

const Header = () => (
  <Row gutter={[8, 0]} style={{ marginBottom: 10 }}>
    <Col flex="1 1 200px">
      <PageHeader title="รายชื่อลูกค้าแบล็คลิส" style={{ fontSize: 20, padding: 0 }} />
    </Col>
  </Row>
);

const blacklistTabKeys = {
  phone: "PHONE",
  bankAccount: "BANK_ACCOUNT",
};

const Blacklist: React.FunctionComponent<IBlacklistProps> = () => {
  const [activeTab, setActiveTab] = React.useState<string>(blacklistTabKeys.phone);

  return (
    <div id="Blacklist">
      <Tabs
        defaultActiveKey={blacklistTabKeys.phone}
        activeKey={activeTab}
        onChange={(v) => setActiveTab(v)}
      >
        <Tabs.TabPane tab="เบอร์โทร" key={blacklistTabKeys.phone}>
          <DeskPanel
            body={
              <>
                <Header />
                <BlacklistTable type="phone" />
              </>
            }
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab="ชื่อบัญชี" key={blacklistTabKeys.bankAccount}>
          <DeskPanel
            body={
              <>
                <Header />
                <BlacklistTable type="bankAccount" />
              </>
            }
          />
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
};

export default Blacklist;
